import { render, staticRenderFns } from "./ntf.vue?vue&type=template&id=04351ca8&"
import script from "./ntf.vue?vue&type=script&lang=js&"
export * from "./ntf.vue?vue&type=script&lang=js&"
import style0 from "./ntf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports